import { useEffect, useState } from 'react';
import qs from 'qs';

import { isPath, isOnCoursesPage } from '@openclassrooms/routing';
import browser from '@openclassrooms/utils/browser';
import { responsiveService, SCREEN_WIDTH_MEDIUM, SCREEN_WIDTH_SMALL } from 'Modules/responsive';

import { UniversalSearchAsync } from 'Modules/universal-search';

const { document } = browser;

function switchHeaderSearchMode(state) {
  const isMobile = [SCREEN_WIDTH_MEDIUM, SCREEN_WIDTH_SMALL].includes(
    responsiveService.getCurrent()
  );

  const headerElement = browser.document.getElementById('oc-header');

  if (!headerElement || isMobile) {
    return;
  }

  headerElement.classList.toggle('mainHeader--hasSearchInputOpened', state);
}

function toggleMainContent(forceOpen) {
  const elementsFlaggedToHide = Array.from(document.querySelectorAll('[data-search-hide-element]'));
  const mainContent =
    browser.document.getElementById('mainContent') ||
    browser.document.getElementById('mainContentWithHeader');

  if (!mainContent && elementsFlaggedToHide.length === 0) {
    return;
  }

  const elementsToToggle = elementsFlaggedToHide.length > 0 ? elementsFlaggedToHide : [mainContent];

  elementsToToggle.forEach((element) => {
    // eslint-disable-next-line no-param-reassign
    element.style.display = forceOpen ? 'block' : 'none';
  });
}

function toggleSubmenu(forceOpen) {
  const submenu = browser.document.getElementById('submenuWrapper');

  if (!submenu) {
    return;
  }

  submenu.style.display = forceOpen ? 'block' : 'none';
}

function toggleContent(forceOpen) {
  toggleMainContent(forceOpen);
  toggleSubmenu(forceOpen);
}

const MainHeaderSearch = () => {
  const [isPotentialSearchPage, togglePotentialSearchPage] = useState(false);

  useEffect(() => {
    const params = qs.parse(document.location.search.slice(1));
    const hasQuerySearch = !!params.query;
    const isSearchPage = isPath(browser.document.location.pathname, '/search');
    const isCoursesPage = isOnCoursesPage();
    togglePotentialSearchPage(isSearchPage || isCoursesPage);

    if (hasQuerySearch && isSearchPage) {
      switchHeaderSearchMode(true);
    }

    return () => toggleContent(true);
  }, [isPotentialSearchPage]);

  return (
    <UniversalSearchAsync
      forceSearchDisplay={isPotentialSearchPage}
      onOpenSearchInput={() => {
        switchHeaderSearchMode(true);
        toggleContent(false);
      }}
      onCloseSearch={() => {
        switchHeaderSearchMode(false);
        toggleContent(true);
      }}
    />
  );
};

export default MainHeaderSearch;
